<template>
    <div class="myPatients">
        <div class="outer-border margin-bottom-three">
            <el-row class="title-border-bottom">
                <div class="b-title fl">我的患者</div>
            </el-row>
            <div class="outer-row">
                <el-row class="margin20">
                    <el-col>
                        <div class="search">
                            <div class="search-inp">
                                <div class="item">
                                    患者姓名:
                                    <el-input size="small" v-model.trim="searchObj.name" clearable
                                        style="width:100px"></el-input>
                                </div>
                                <div class="item">
                                    性别:
                                    <el-select size="small" v-model="searchObj.sex" placeholder="" clearable
                                        style="width:60px">
                                        <el-option label="男" value="男"></el-option>
                                        <el-option label="女" value="女"></el-option>
                                    </el-select>
                                </div>
                                <!-- <div class="item">
                                    年龄:
                                    <el-input
                                        size="small"
                                        clearable
                                        v-model.trim="searchObj.age"
                                        style="width:60px"
                                    ></el-input>
                                </div> -->
                                <!-- <div class="item">
                                    主要症状:
                                    <el-input
                                        size="small"
                                        v-model.trim="searchObj.disease"
                                        clearable
                                        style="width:100px"
                                    ></el-input>
                                </div> -->
                                <!-- <div class="item">
                                    医案类型:
                                    <el-select
                                        size="small"
                                        v-model="searchObj.yaType"
                                        clearable
                                        style="width:100px"
                                    >
                                        <el-option label="自建" value="自建"></el-option>
                                        <el-option label="患者创建" value="患者创建"></el-option>
                                    </el-select>
                                </div> -->
                                <!-- <div class="item">
                                    回复状态:
                                    <el-select
                                        size="small"
                                        v-model="searchObj.reply"
                                        clearable
                                        style="width:100px"
                                    >
                                        <el-option label="已回复" value="已回复"></el-option>
                                        <el-option label="未回复" value="未回复"></el-option>
                                    </el-select>
                                </div>
                                <div class="item">
                                    最后一次沟通时间:
                                    <el-date-picker
                                        size="small"
                                        v-model="date"
                                        type="daterange"
                                        value-searchObjat="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        clearable
                                        style="width:220px"
                                    ></el-date-picker>
                                </div> -->
                                <div class="item padding5">
                                    <el-button type="danger" class="fl" size="mini"
                                        @click="getHuanzhe(1)">搜索</el-button>
                                    <el-button type="primary" class="fl" size="mini"
                                        @click="addMedicalRecords()">新建医案</el-button>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="margin20">
                    <el-col :span="24">
                        <el-table :data="tableData" border style="width: 100%" class="myTable">
                            <el-table-column type="index" width="60" label="序号"></el-table-column>
                            <el-table-column prop="name" label="姓名"></el-table-column>
                            <el-table-column prop="sex" label="性别"></el-table-column>
                            <el-table-column prop="age" label="年龄"></el-table-column>
                            <el-table-column label="医案类型">
                                <template>自建</template>
                            </el-table-column>
                            <!-- <el-table-column label="主要症状">
                                <template slot-scope="scope">{{limitMaxWords(15,scope.row.disease)}}</template>
                            </el-table-column> -->
                            <!-- <el-table-column label="就诊时间">
                                <template slot-scope="scope">{{getTime(scope.row.visiTime)}}</template>
                            </el-table-column>
                            <el-table-column label="最后一次沟通时间">
                                <template slot-scope="scope">{{getTime(scope.row.date)}}</template>
                            </el-table-column> 
                            <el-table-column prop="reply"  width="90" label="回复状态"></el-table-column>-->
                            <el-table-column fixed="right" width="120" label="操作">
                                <template slot-scope="scope">
                                    <div class="btns">
                                        <el-button @click="viewF(scope.row)" type="text" size="small">查看</el-button>
                                        <el-button @click="goDiagnosis(scope.row)" type="text" size="small">前往诊断</el-button>
                                    </div> 
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-pagination background layout="total,prev, pager, next,jumper" :total="searchObj.total"
                            :page-size="searchObj.pageSize" :current-page.sync="searchObj.pageNum"
                            @current-change="handleCurrentChange"></el-pagination>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "myPatients",
    data() {
        return {
            date: null,
            searchObj: {
                name: "",
                sex: "",
                age: "",
                disease: "",
                yaType: "",
                reply: "",
                total: 0, // 总数量
                pageNum: 1, // 当前第几页
                pageSize: 10 // 当前页数量条数
            },
            tableData: []
        };
    },
    methods: {
        //选页
        handleCurrentChange(v) {
            let that = this;
            that.searchObj.pageNum = v; //当前页
            that.getHuanzhe();
        },
        //患者列表
        async getHuanzhe(a) {
            let that = this;
            if (a) {
                that.searchObj.pageNum = 1;
            }
            // that.searchObj.userId = that.userInfo.id;
            let url = "medicalCasesPc/getYaByUserId";
            await that.$http
                .post(url, that.searchObj)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        that.tableData = res.data.list;
                        that.searchObj.total = res.data.total;
                        that.searchObj.pageSize = res.data.pageSize;
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        },

        viewF(row) {
            let pathStr = '/diagnosticDetails'
            if(this.userInfo.userType==2){ //医师
                pathStr = '/diagnosticDetailsT'
            } 
            this.$router.push({
                path: pathStr,
                query: {
                    id: row.id

                }
            });
        },
        //我的患者，前往诊断
        goDiagnosis(row) {
            this.$router.push({
                path: "/diagnosisT",
                query: { id: row.id }
            });
        },
        addMedicalRecords() {
            this.$router.push({
                path: "/tradiAddMedical"
            });
        }
    },
    created() {
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            this.getHuanzhe();
        }
    }
};
</script>

<style scoped>
.padding5 {
    padding: 5px;
}

.search {
    display: flex;
    align-items: center;
}

.item {
    float: left;
    margin-right: 20px;
    font-size: 14px;
}

.search-inp .item .el-input,
.search-inp .item .el-date-editor,
.search-inp .item .el-select {
    margin: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/JW/myPatients.vue